export default __webpack_public_path__ + "static/media/la-solid-900.3efd5ba1.woff2";